export enum SELECT_SHIPPING_METHOD_EXTERNAL_SERVICES {
  fetchShippingMethods = 'fetchShippingMethods',
}
